export default "__VITE_ASSET__e8A$T0yE__"